import store from '@/store'
import eventBus from '@/helpers/event-bus'

export default function (_this) {
  return {
    create (data, tab, callback) {
      let newSpreadsheet = {
        title: data.title,
        key: data.key,
        activeSheet: data.key,
        columnCount: 7,
        rowCount: 10,
        data: data.excelData
      }

      if (data.isLocal) newSpreadsheet.isLocal = true

      let addSheetWidget = () => {
        return new Promise((resolve) => {
          let key = _this.getRef('widgets').push({ template: '' }, () => {
            resolve(key)
          }).key
        })
      }

      let fillWidgetWithData = (key) => {
        let newWidget = {
          template: `<Spreadsheet :data="spreadsheets.${data.key}" />`,
          gsOptions: {
            x: 0,
            y: 0,
            w: 12,
            h: 5
          },
          tab: tab,
          dependencies: {
            spreadsheets: data.key
          }
        }

        _this.getRef('widgets').child(key)
          .update(newWidget, () => { if (callback) callback() })
      }

      let promise = new Promise((resolve) => {
        _this.getRef('widgetsData/spreadsheets').child(data.key)
          .set(newSpreadsheet, (err) => {
            if (err) callback(err)
            else resolve()
          })
      })

      promise
        .then(() => {
          return addSheetWidget()
        })
        .then((key) => {
          fillWidgetWithData(key)
        })
    },
    read (dashboard, callback) {
      _this.dashRef.child(dashboard + '/widgetsData/spreadsheets')
        .once('value', (snapshot) => {
          callback(snapshot.val())
        })
    },
    updateCell ({ sheet, cell, value }, callback) {
      if (~sheet.indexOf('.')) sheet = sheet.replace(/\./, '/subsheets/')

      let cellAddress = sheet + '/data/' + cell
      let formulaAddress = sheet + '/formulas/' + cell

      if (value !== '') {
        if (value[0] === '=') {
          _this.getRef('widgetsData/spreadsheets')
            .child(formulaAddress).set(true)
        }
        _this.getRef('widgetsData/spreadsheets').child(cellAddress).set(value, (err) => {
          eventBus.$emit('onSpreadsheetUpdate')
          if (err) {
            callback(err)
          }
        })
      } else {
        _this.getRef('widgetsData/spreadsheets')
          .child(formulaAddress).remove()
        _this.getRef('widgetsData/spreadsheets').child(cellAddress).remove((err) => {
          eventBus.$emit('onSpreadsheetUpdate')
          if (err) {
            callback(err)
          }
        })
      }
    },
    updateLocalSpreadsheetCell ({ sheet, cell, value }) {
      const sheetAddress = sheet.split('.')
      const parentSheet = sheetAddress[0]
      const sheetToUpdate = window._.clone(store.state.localSpreadsheets[parentSheet])
      const isChild = sheetAddress.length > 1

      if (value !== '') {
        if (isChild) {
          if (value[0] === '=') {
            if (!sheetToUpdate['subsheets'][sheetAddress[1]]['formulas']) {
              sheetToUpdate['subsheets'][sheetAddress[1]]['formulas'] = {}
            }
            sheetToUpdate['subsheets'][sheetAddress[1]]['formulas'][cell] = true
          }
          if (!sheetToUpdate['subsheets'][sheetAddress[1]]['data']) {
            sheetToUpdate['subsheets'][sheetAddress[1]]['data'] = {}
          }
          sheetToUpdate['subsheets'][sheetAddress[1]]['data'] = value
        } else {
          if (value[0] === '=') {
            if (!sheetToUpdate['formulas']) {
              sheetToUpdate['formulas'] = {}
            }
            sheetToUpdate['formulas'][cell] = true
          }
          if (!sheetToUpdate['data'][cell]) {
            sheetToUpdate['data'][cell] = {}
          }
          sheetToUpdate['data'][cell] = value
        }
      } else {

      }
      console.log(sheetToUpdate)
    },
    update (sheet, data, callback) {
      if (~sheet.indexOf('.')) sheet = sheet.replace(/\./, '/subsheets/')

      _this.getRef('widgetsData/spreadsheets').child(sheet + '/data').update(data, () => {
        if (callback) callback()
      })
    },
    addSubsheet (parent, data, callback) {
      let sheetData = {
        title: data.title,
        key: parent + '.' + data.key,
        columnCount: 7,
        rowCount: 10,
        data: data.excelData
      }

      _this.getRef('widgetsData/spreadsheets').child(parent + '/subsheets/' + data.key)
        .set(sheetData, () => {
          _this.getRef('widgetsData/spreadsheets').child(parent + '/activeSheet').set(parent + '.' + data.key)
          callback()
        })
    },
    setActive (sheet) {
      let sheetToUpdate = sheet
      if (~sheet.indexOf('.')) {
        let sheetEls = sheet.split('.')
        sheetToUpdate = sheetEls[0]
      }

      _this.getRef('widgetsData/spreadsheets')
        .child(sheetToUpdate + '/activeSheet').set(sheet)
    },
    rename (sheet, title, callback) {
      if (~sheet.indexOf('.')) sheet = sheet.replace(/\./, '/subsheets/')

      _this.getRef('widgetsData/spreadsheets').child(sheet + '/title').set(title, (err) => {
        if (err) callback(err)
        else callback(null)
      })
    },
    delete (sheetToDelete, sheets, callback) {
      for (let sheet of sheets) {
        if (sheet.key === sheetToDelete) continue
        this.setActive(sheet.key)
        break
      }

      if (~sheetToDelete.indexOf('.')) {
        sheetToDelete = sheetToDelete.replace(/\./, '/subsheets/')
        _this.getRef('widgetsData/spreadsheets').child(sheetToDelete).remove((err) => {
          if (err) callback(err)
          else callback(null)
        })
      } else {
        _this.getRef('widgetsData/spreadsheets').child(sheetToDelete + '/data').remove((err) => {
          if (err) callback(err)
          else callback(null)
        })
        _this.getRef('widgetsData/spreadsheets').child(sheetToDelete + '/rootDeleted').set(true)
      }
    },
    setColumnCount (sheet, count) {
      sheet = sheet.replace(/\./, '/subsheets/')
      _this.getRef('widgetsData/spreadsheets').child(sheet + '/columnCount').set(count)
    },
    setRowCount (sheet, count) {
      sheet = sheet.replace(/\./, '/subsheets/')
      _this.getRef('widgetsData/spreadsheets').child(sheet + '/rowCount').set(count)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/db/sheets.js